import Vue from "vue";
import Router from "vue-router";
import login from "@/components/login";
import changePassword from "@/components/changePassword";
import print from "@/components/pages/print";
import print1 from "@/components/pages/print1";
import print2 from "@/components/pages/print2";

Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [{
            path: "/",
            redirect: "/login"
        },
        {
            path: "/login",
            component: login
        },
        {
            path: "/print",
            component: print
        },
        {
            path: "/print1",
            component: print1
        },
        {
            path: "/print2",
            component: print2
        },
        {
            path: '/Home',
            component: resolve => require(["@/components/layout/Home.vue"], resolve),
            children: [
                // 首页
                {
                    path: "HomePage",
                    component: resolve =>
                        require(["@/components/pages/Home"], resolve),
                    meta: {
                        userType: 1,
                        isNeedLogin: false,
                    },
                },
                // 首页
                // 产品
                {
                    path: "Product",
                    component: resolve =>
                        require(["@/components/pages/Home/product/Product.vue"], resolve),
                    meta: {
                        userType: 1,
                        isNeedLogin: false,
                    },
                },
                {
                    path: "Logistics",
                    component: resolve =>
                        require(["@/components/pages/Home/product/Logistics.vue"], resolve),
                    meta: {
                        userType: 1,
                        isNeedLogin: false,
                    },
                },
                // 产品
                // 服务
                {
                    path: "Tool",
                    component: resolve =>
                        require(["@/components/pages/Home/server/Tool.vue"], resolve),
                    meta: {
                        userType: 1,
                        isNeedLogin: false,
                    },
                },
                {
                    path: "ServerQuestion",
                    component: resolve =>
                        require(["@/components/pages/Home/server/ServerQuestion.vue"], resolve),
                    meta: {
                        userType: 1,
                        isNeedLogin: false,
                    },
                },
                {
                    path: "ServerCenter",
                    component: resolve =>
                        require(["@/components/pages/Home/server/ServerCenter.vue"], resolve),
                    meta: {
                        userType: 1,
                        isNeedLogin: false,
                    },
                },
                // 服务
                // 关于我们
                {
                    path: "Us",
                    component: resolve =>
                        require(["@/components/pages/Home/aboutUs/Us.vue"], resolve),
                    meta: {
                        userType: 1,
                        isNeedLogin: false,
                    },
                },
                // 关于我们
                // 流程
                {
                    path: "CooperateOrder",
                    component: resolve =>
                        require(["@/components/pages/Home/order/CooperateOrder.vue"], resolve),
                    meta: {
                        userType: 1,
                        isNeedLogin: false,
                    },
                },
                {
                    path: "NewHandle",
                    component: resolve =>
                        require(["@/components/pages/Home/order/NewHandle.vue"], resolve),
                    meta: {
                        userType: 1,
                        isNeedLogin: false,
                    },
                },
                // 流程
                // 资讯
                {
                    path: "Information",
                    component: resolve =>
                        require(["@/components/pages/Home/information/Information.vue"], resolve),
                    meta: {
                        userType: 1,
                        isNeedLogin: false,
                    },
                },
                {
                    path: "InformationDetail",
                    component: resolve =>
                        require(["@/components/pages/Home/information/InformationDetail.vue"], resolve),
                    meta: {
                        userType: 1,
                        isNeedLogin: false,
                    },
                },
                // 资讯
                // 工具
                {
                    path: "DataDownload",
                    component: resolve =>
                        require(["@/components/pages/Home/tool/DataDownload.vue"], resolve),
                    meta: {
                        userType: 1,
                        isNeedLogin: false,
                    },
                },
                // 工具
            ],
        },
        {
            path: "/",
            component: resolve => require(["../components/layout/User.vue"], resolve),
            children: [{
                    path: "/dashboard",
                    component: resolve =>
                        require(["../components/dashboard.vue"], resolve)
                },
                {
                    path: "settlementExchange",
                    component: resolve =>
                        require(["../components/pages/foreignExchange/settlementExchange/settlementExchange.vue"], resolve)
                },
                {
                    path: "settlementExchange2",
                    component: resolve =>
                        require(["../components/pages/foreignExchange/settlementExchange/settlementExchange2.vue"], resolve)
                },
                {
                    path: "settlementApplication",
                    component: resolve =>
                        require(["../components/pages/foreignExchange/settlementApplication/settlementApplication.vue"], resolve)
                },
                {
                    path: "settlement",
                    component: resolve =>
                        require(["../components/pages/foreignExchange/settlement/settlement.vue"], resolve)
                },
                {
                    path: "toBeRecorded",
                    component: resolve =>
                        require(["../components/pages/Arrival/toBeRecorded.vue"], resolve)
                },
                {
                    path: "toBeRecorded2",
                    component: resolve =>
                        require(["../components/pages/Arrival/toBeRecorded2.vue"], resolve)
                },
                {
                    path: "entry",
                    component: resolve =>
                        require(["../components/pages/Arrival/entry.vue"], resolve)
                },
                {
                    path: "entry2",
                    component: resolve =>
                        require(["../components/pages/Arrival/entry2.vue"], resolve)
                },
                {
                    path: "sccountAudit",
                    component: resolve =>
                        require(["../components/pages/foreignExchange/sccountAudit/sccountAudit.vue"], resolve)
                },


                {
                  path: "/changePassword",
                  component: changePassword,
                },
              {
                path: "bankAcount",
                component: resolve =>
                  require(["../components/pages/foreignExchange/bank/acount.vue"], resolve)
              },
              {
                path: "bankCurrencyPairs",
                component: resolve =>
                  require(["../components/pages/foreignExchange/bank/currencyPairs.vue"], resolve)
              },
              //Bases
                {
                    path: "customsCode",
                    component: resolve =>
                        require(["../components/pages/Bases/customsCode.vue"], resolve)
                },
                {
                    path: "productManage",
                    component: resolve =>
                        require(["../components/pages/Bases/productManage.vue"], resolve)
                },
                {
                    path: "foreignCurrencyAccount",
                    component: resolve =>
                        require([
                            "../components/pages/Bases/foreignCurrencyAccount.vue"
                        ], resolve)
                },
                {
                    path: "subsidiary",
                    component: resolve =>
                        require(["../components/pages/Bases/subsidiary.vue"], resolve)
                },
                {
                    path: "valueAddedTax",
                    component: resolve =>
                        require(["../components/pages/Bases/valueAddedTax.vue"], resolve)
                },
                {
                    path: "customDeclareClearance",
                    component: resolve =>
                        require([
                            "../components/pages/Bases/customDeclareClearance.vue"
                        ], resolve)
                },
                {
                    path: "exchangePiont",
                    component: resolve =>
                        require(["../components/pages/Bases/exchangePiont.vue"], resolve)
                },
                {
                    path: "currencyAndExchangeRate",
                    component: resolve =>
                        require([
                            "../components/pages/Bases/currencyAndExchangeRate.vue"
                        ], resolve)
                },
                {
                    path: "exporterDestination",
                    component: resolve =>
                        require([
                            "../components/pages/Bases/exporterDestination.vue"
                        ], resolve)
                },
                {
                    path: "domesticSupply",
                    component: resolve =>
                        require(["../components/pages/Bases/domesticSupply.vue"], resolve)
                },
                {
                    path: "information",
                    component: resolve =>
                        require(["../components/pages/Bases/information.vue"], resolve)
                },
                {
                    path: "packagingInformation",
                    component: resolve =>
                        require([
                            "../components/pages/Bases/packagingInformation.vue"
                        ], resolve)
                },
                {
                    path: "legalUnits",
                    component: resolve =>
                        require(["../components/pages/Bases/legalUnits.vue"], resolve)
                },
              {
                path: "companyHead",
                component: resolve =>
                  require(["../components/pages/Bases/companyHead.vue"], resolve)
              },
              {
                path: "companyHeadForeign",
                component: resolve =>
                  require(["../components/pages/Bases/companyHeadForeign.vue"], resolve)
              },
                {
                    path: "productCategories",
                    component: resolve =>
                        require([
                            "../components/pages/Bases/productCategories.vue"
                        ], resolve)
                },
                {
                    path: "registrationService",
                    component: resolve =>
                        require([
                            "../components/pages/Bases/registrationService.vue"
                        ], resolve)
                },
                {
                    path: "registrationType",
                    component: resolve =>
                        require(["../components/pages/Bases/registrationType.vue"], resolve)
                },
                {
                    path: "deliveryInformation",
                    component: resolve =>
                        require([
                            "../components/pages/Bases/deliveryInformation.vue"
                        ], resolve)
                },
                //Bases
                //运单管理 WaybillManage
                {
                    path: "totalWaybill",
                    component: resolve =>
                        require(["../components/pages/WaybillManage/TotalWaybill.vue"], resolve)
                },
                {
                    path: "totalWaybillDeatil",
                    component: resolve =>
                        require(["../components/pages/WaybillManage/TotalWaybillDeatil.vue"], resolve),
                        meta: {
                            activeMenu:'/totalWaybill'
                        },
                },
                {
                    path: "orderList",
                    component: resolve =>
                        require(["../components/pages/WaybillManage/OrderList.vue"], resolve)
                },
                {
                    path: "declarationList",
                    component: resolve =>
                        require(["../components/pages/WaybillManage/DeclarationList.vue"], resolve)
                },
                // 易货贸易
                {
                    path: "tradeList",
                    component: resolve =>
                        require(["../components/pages/tradeManage/tradeList.vue"], resolve)
                },
                {
                    path: "jointOrderList",
                    component: resolve =>
                        require(["../components/pages/jointOrderManage/jointOrderList.vue"], resolve)
                },
                //ProductManage 商品管理
                {
                    path: "productlist",
                    component: resolve =>
                        require(["../components/pages/ProductManage/productlist.vue"], resolve)
                },
                //正和港产业园-选品中心
                {
                    path: "mallCategory",
                    component: resolve =>
                        require(["../components/pages/mall/categoryList.vue"], resolve)
                },
                {
                    path: "mallProduct",
                    component: resolve =>
                        require(["../components/pages/mall/productList.vue"], resolve)
                },
                {
                    path: "mallInquiry",
                    component: resolve =>
                        require(["../components/pages/mall/inquiryList.vue"], resolve)
                },
                {
                    path: "mallFavorite",
                    component: resolve =>
                        require(["../components/pages/mall/favoriteList.vue"], resolve)
                },
                //Customer
                {
                    path: "customerAudit",
                    component: resolve =>
                        require(["../components/pages/Customer/customerAudit.vue"], resolve)
                },
                {
                    path: "InformationAudit",
                    component: resolve =>
                        require(["../components/pages/Customer/InformationAudit.vue"], resolve)
                },
                {
                    path: "InformationAuditDetail",
                    component: resolve =>
                        require(["../components/pages/Customer/InformationAuditDetail.vue"], resolve)
                },
                {
                    path: "customerList",
                    component: resolve =>
                        require(["../components/pages/Customer/customerList.vue"], resolve)
                },
                {
                  path: "driverList",
                  component: resolve =>
                      require(["../components/pages/Customer/driverList.vue"], resolve)
              },
                {
                    path: "passCustomerDetail",
                    component: resolve =>
                        require(["../components/pages/Customer/passCustomerDetail.vue"], resolve)
                },
                {
                    path: "solution",
                    component: resolve =>
                        require(["../components/pages/Customer/solution.vue"], resolve)
                },
                {
                    path: "applyAccount",
                    component: resolve =>
                        require(["../components/pages/Customer/applyAccount.vue"], resolve)
                },
                {
                    path: "applyAccountDetail",
                    component: resolve =>
                        require(["../components/pages/Customer/applyAccountDetail.vue"], resolve)
                },
                {
                    path: "customerDetail",
                    component: resolve =>
                        require([
                            "../components/pages/Customer/customerDetail.vue"
                        ], resolve)
                },
                {
                    path: "customerBind",
                    component: resolve =>
                        require([
                            "../components/pages/Customer/customerBind.vue"
                        ], resolve)
                },
                {
                    path: "foreignAccount",
                    component: resolve =>
                        require(["../components/pages/Customer/ForeignAccount.vue"], resolve)
                },
                {
                    path: "foreignAccountDetail",
                    component: resolve =>
                        require(["../components/pages/Customer/ForeignAccountDetail.vue"], resolve)
                },
                //Customer

              //brand

              {
                path: "addBrand",
                component: resolve =>
                  require([
                    "../components/pages/brand/addBrand.vue"
                  ], resolve)
              },
              {
                path: "brandList",
                component: resolve =>
                  require([
                    "../components/pages/brand/brandList.vue"
                  ], resolve)
              },
              //Loading
              // {
              //   path: "orderContains",
              //   component: resolve =>
              //     require([
              //       "../components/pages/Loading/loadPhoto.vue"
              //     ], resolve)
              // },
              {
                path: "orderContains",
                component: resolve =>
                  require([
                    "../components/pages/Loading/loadList.vue"
                  ], resolve)
              },
              {
                path: "loadPhoto",
                component: resolve =>
                  require([
                    "../components/pages/Loading/loadPhoto.vue"
                  ], resolve)
              },
              // {
              //   path: "loadLeaflet",
              //   component: resolve =>
              //     require([
              //       "../components/pages/Loading/loadLeaflet.vue"
              //     ], resolve)
              // },
                //Audit
                {
                  path: "foreignExchange",
                  component: resolve =>
                      require([
                          "../components/pages/Audit/foreignExchange.vue"
                      ], resolve)
              },
                {
                    path: "stuffingLog",
                    component: resolve =>
                        require([
                            "../components/pages/Audit/stuffingLog.vue"
                        ], resolve)
                },
                {
                    path: "stuffingPhoto",
                    component: resolve =>
                        require([
                            "../components/pages/Audit/stuffingPhoto.vue"
                        ], resolve)
                },
                {
                    path: "billLog",
                    component: resolve =>
                        require([
                            "../components/pages/Customer/billLog.vue"
                        ], resolve)
                },
                {
                    path: "exportOrdersAudit",
                    component: resolve =>
                        require([
                            "../components/pages/Audit/exportOrdersAudit.vue"
                        ], resolve)
                },
                {
                    path: "exportOrdersAuditCheck",
                    component: resolve =>
                        require([
                            "../components/pages/Audit/exportOrdersAuditCheck.vue"
                        ], resolve)
                },
              {
                path: "exportOrdersAuditErp",
                component: resolve =>
                  require([
                    "../components/pages/Audit/exportOrdersAuditErp.vue"
                  ], resolve)
              },
              {
                path: "exportOrderFinance",
                component: resolve =>
                  require([
                    "../components/pages/Audit/exportOrderFinance.vue"
                  ], resolve),
              },
                {
                    path: "playAnOrder",
                    component: resolve =>
                        require([
                            "../components/pages/Audit/playAnOrder.vue"
                        ], resolve)
                },
                {
                    path: "productPreAuditDetail",
                    component: resolve =>
                        require(["../components/pages/Audit/productPreAuditDetail.vue"], resolve)
                },
                {
                    path: "productPreAudit",
                    component: resolve =>
                        require(["../components/pages/Audit/productPreAudit.vue"], resolve)
                },
                {
                    path: "importOrdersAudit",
                    component: resolve =>
                        require(["../components/pages/Audit/importOrdersAudit.vue"], resolve)
                },
                {
                    path: "drawerAudit",
                    component: resolve =>
                        require(["../components/pages/Audit/drawerAudit.vue"], resolve)
                },
                {
                    path: "drawerAuditDetail",
                    component: resolve =>
                        require(["../components/pages/Audit/drawerAuditDetail.vue"], resolve)
                },
                {
                  path: "TheErp",
                  component: resolve =>
                      require(["../components/pages/Audit/TheErp.vue"], resolve)
              },
                {
                  path: "exportOrderChange",
                  component: resolve =>
                      require(["../components/pages/Audit/exportOrderChange.vue"], resolve)
                },
                {
                  path: "setuporder",
                  component: resolve =>
                      require(["../components/pages/Audit/setuporder.vue"], resolve)
                },
                // 进口订单核实
                {
                    path: "importOrdersAuditCheck",
                    component: resolve =>
                    require(["../components/pages/Audit/importOrdersAuditCheck.vue"], resolve)
                },
                // 进口订单-修改订单
                {
                    path: "importOrderChange",
                    component: resolve =>
                    require(["../components/pages/Audit/importOrderChange.vue"], resolve)
                },
                //Audit
                //systemSetting
                {
                    path: "adminManage",
                    component: resolve =>
                        require(["../components/pages/systemSetting/adminManage.vue"], resolve)
                },
                {
                    path: "bankUser",
                    component: resolve =>
                        require(["../components/pages/systemSetting/bankUser.vue"], resolve)
                },
                {
                    path: "paramsSetting",
                    component: resolve =>
                        require(["../components/pages/systemSetting/paramsSetting.vue"], resolve)
                },
                {
                    path: "systemAuthority",
                    component: resolve =>
                        require(["../components/pages/systemSetting/systemAuthority.vue"], resolve)
                },
                {
                    path: "seo",
                    component: resolve =>
                        require(["../components/pages/systemSetting/seo.vue"], resolve)
                },
                {
                    path: "actionLog",
                    component: resolve =>
                        require(["../components/pages/systemSetting/actionLog.vue"], resolve)
                },
                //systemSetting
                //serverManage
                {
                    path: "freightRegistDetail",
                    component: resolve =>
                        require(["../components/pages/serverManage/FreightRegistDetail.vue"], resolve)
                },
                {
                    path: "freightChangeDetail",
                    component: resolve =>
                        require(["../components/pages/serverManage/FreightChangeDetail.vue"], resolve)
                },
                {
                    path: "freightProvideChangeAudit",
                    component: resolve =>
                        require(["../components/pages/serverManage/FreightProvideChangeAudit.vue"], resolve)
                },
                {
                    path: "freightProvideRegistAudit",
                    component: resolve =>
                        require(["../components/pages/serverManage/FreightProvideRegistAudit.vue"], resolve)
                },
                {
                    path: "serverAudit",
                    component: resolve =>
                        require(["../components/pages/serverManage/serverAudit.vue"], resolve)
                },
                {
                    path: "serverList",
                    component: resolve =>
                        require(["../components/pages/serverManage/serverList.vue"], resolve)
                },
                {
                    path: "clearManage",
                    component: resolve =>
                        require(["../components/pages/serverManage/clearManage.vue"], resolve)
                },
                //serverManage
                // pagesEditor
                {
                    path: "columnManage",
                    component: resolve =>
                        require(["../components/pages/pagesEditor/columnManage.vue"], resolve)
                },
                {
                    path: "articleManage",
                    component: resolve =>
                        require(["../components/pages/pagesEditor/articleManage.vue"], resolve)
                },
                {
                    path: "pagesSource",
                    component: resolve =>
                        require(["../components/pages/pagesEditor/pagesSource.vue"], resolve)
                },
                {
                    path: "messageInformation",
                    component: resolve =>
                        require(["../components/pages/pagesEditor/messageInformation.vue"], resolve)
                },
                {
                  path: "helpclass",
                  component: resolve =>
                      require(["../components/pages/pagesEditor/helpclass.vue"], resolve)
              },
              {
                path: "helplist",
                component: resolve =>
                    require(["../components/pages/pagesEditor/helplist.vue"], resolve)
            },
                // pagesEditor
                // 用友信息
                {
                    path: "stockManage",
                    component: resolve =>
                        require(["../components/pages/YongYou/stockManage.vue"], resolve)
                },
                {
                    path: "customManage",
                    component: resolve =>
                        require(["../components/pages/YongYou/customManage.vue"], resolve)
                },
                {
                    path: "supplierManage",
                    component: resolve =>
                        require(["../components/pages/YongYou/supplierManage.vue"], resolve)
                },
                {
                    path: "classManage",
                    component: resolve =>
                        require(["../components/pages/YongYou/classManage.vue"], resolve)
                },
                {
                    path: "businessManage",
                    component: resolve =>
                        require(["../components/pages/YongYou/businessManage.vue"], resolve)
                },
                {
                    path: "salesType",
                    component: resolve =>
                        require(["../components/pages/YongYou/salesType.vue"], resolve)
                },
                {
                    path: "spplyType",
                    component: resolve =>
                        require(["../components/pages/YongYou/spplyType.vue"], resolve)
                },
                {
                    path: "receiver",
                    component: resolve =>
                        require(["../components/pages/YongYou/receiver.vue"], resolve)
                },
                {
                    path: "tradeType",
                    component: resolve =>
                        require(["../components/pages/YongYou/tradeType.vue"], resolve)
                },
                {
                    path: "changeArticle",
                    component: resolve =>
                        require(["../components/pages/pagesEditor/changeArticle.vue"], resolve)
                },
                // 用友信息
                //消息中心
                {
                    path: "messageCenter",
                    component: resolve =>
                        require(["../components/pages/messageCenter/messageCenter.vue"], resolve)
                },
                // 系统管理
                {
                    path: "adminList",
                    component: resolve =>
                        require(["../components/pages/roleFunction/AdminList.vue"], resolve)
                },
                {
                    path: "roleList",
                    component: resolve =>
                        require(["../components/pages/roleFunction/RoleList.vue"], resolve)
                },
                {
                    path: "createRole",
                    component: resolve =>
                        require(["../components/pages/roleFunction/CreateRole.vue"], resolve)
                },
                {
                  path: "action",
                  component: resolve =>
                      require(["../components/pages/roleFunction/action.vue"], resolve)
              },
                // 出口费用单管理
                {
                  path: "billList",
                  component: resolve =>
                      require(["../components/pages/billManage/billList.vue"], resolve)
                },
                {
                  path: "billDetail",
                  component: resolve =>
                      require(["../components/pages/billManage/billDetail.vue"], resolve)
                },
                //金融管理
                {  //三证合一
                  path: "certificate",
                  component: resolve =>
                      require(["../components/pages/OrderbillManage/certificate.vue"], resolve)
                },
                {  //产地证书
                  path: "place",
                  component: resolve =>
                      require(["../components/pages/OrderbillManage/place.vue"], resolve)
                },
                {  //金融单据
                  path: "finance",
                  component: resolve =>
                      require(["../components/pages/OrderbillManage/finance.vue"], resolve)
                },
                {  //银行人员金融单据
                  path: "bankfinance",
                  component: resolve =>
                      require(["../components/pages/OrderbillManage/bankfinance.vue"], resolve)
                },
                {  //新增三证合一
                  path: "certificateadd",
                  component: resolve =>
                      require(["../components/pages/OrderbillManage/certificateadd.vue"], resolve)
                },
                {  //出口明细
                  path: "exitdetail",
                  component: resolve =>
                      require(["../components/pages/OrderbillManage/exitdetail.vue"], resolve)
                },
                {  //进口明细
                  path: "purchasedetail",
                  component: resolve =>
                      require(["../components/pages/OrderbillManage/purchasedetail.vue"], resolve)
                },
                {  //出口明细placeadd
                  path: "drawbackinput",
                  component: resolve =>
                      require(["../components/pages/OrderbillManage/drawbackinput.vue"], resolve)
                },
                {  //出口明细
                  path: "placeadd",
                  component: resolve =>
                      require(["../components/pages/OrderbillManage/placeadd.vue"], resolve)
                },
                //轮播图管理
                {
                    path: "swiperManage",
                    component: resolve =>
                        require(["../components/pages/swiperManage/SwiperManage.vue"], resolve)
                },
                //物流货代
                //货代列表
                {
                    path: "freightOrderList",
                    component: resolve =>
                        require(["../components/pages/FreightOrderManage/FreightOrderList.vue"], resolve)
                },
                //货代详情
                {
                    path: "freightDetail",
                    component: resolve =>
                        require(["../components/pages/FreightOrderManage/FreightDetail.vue"], resolve)
                },
                //货代申请列表
                {
                    path: "freightOrderApply",
                    component: resolve =>
                        require(["../components/pages/FreightOrderManage/FreightOrderApply.vue"], resolve)
                },
                //申请详情
                {
                    path: "applyDetail",
                    component: resolve =>
                        require(["../components/pages/FreightOrderManage/ApplyDetail.vue"], resolve)
                },
                //生成账单
                  {
                  path: "freightGenerate",
                  component: resolve =>
                      require(["../components/pages/FreightOrderManage/freightGenerate.vue"], resolve)
              },
                  //查看账单
                  {
                    path: "freightBill",
                    component: resolve =>
                        require(["../components/pages/FreightOrderManage/freightBill.vue"], resolve)
                 },
                //验单发送
                {
                    path: "submitInspectionGoods",
                    component: resolve =>
                        require(["../components/pages/InspectionGoodsManage/SubmitInspectionGoods.vue"], resolve)
                },
                //验单员列表
                {
                    path: "inspectionPersons",
                    component: resolve =>
                        require(["../components/pages/InspectionGoodsManage/InspectionPersons.vue"], resolve)
                },
                //验单员列表-申请详情
                {
                    path: "inspectionPersonsDetail",
                    component: resolve =>
                        require(["../components/pages/InspectionGoodsManage/InspectionPersonsDetail.vue"], resolve)
                },
                //验单列表
                {
                    path: "inspectionGoods",
                    component: resolve =>
                        require(["../components/pages/InspectionGoodsManage/InspectionGoods.vue"], resolve)
                },
                //验单列表-验单详情
                {
                    path: "inspectionGoodsDetail",
                    component: resolve =>
                        require(["../components/pages/InspectionGoodsManage/InspectionGoodsDetail.vue"], resolve)
                },
                //提现申请列表
                {
                    path: "withdraws",
                    component: resolve =>
                        require(["../components/pages/InspectionGoodsManage/Withdraws.vue"], resolve)
                },

              // 用户单据统计
              //查验率
              {
                path: "check",
                component: resolve =>
                  require(["../components/pages/statistics/check.vue"], resolve)
              },
              //查验率
              {
                path: "checkDetail",
                component: resolve =>
                  require(["../components/pages/statistics/checkDetailList.vue"], resolve)
              },

              //通过率
              {
                path: "pass",
                component: resolve =>
                  require(["../components/pages/statistics/pass.vue"], resolve)
              },
              //通过率
              {
                path: "passDetail",
                component: resolve =>
                  require(["../components/pages/statistics/passDetailList.vue"], resolve)
              },
              //出口单据产品统计
              {
                path: "importProduct",
                component: resolve =>
                  require(["../components/pages/statistics/importProduct.vue"], resolve)
              },
              //出口单据产品统计
              {
                path: "importProductDetail",
                component: resolve =>
                  require(["../components/pages/statistics/importProductDetail.vue"], resolve)
              },
              //进口单据产品统计
              {
                path: "exportProduct",
                component: resolve =>
                  require(["../components/pages/statistics/exportProduct.vue"], resolve)
              },
              //进口单据产品统计
              {
                path: "exportProductDetail",
                component: resolve =>
                  require(["../components/pages/statistics/exportProductDetail.vue"], resolve)
              },
              //常出货国
              {
                path: "destcountry",
                component: resolve =>
                  require(["../components/pages/statistics/destcountry.vue"], resolve)
              },
              //产品统计
              {
                path: "userProduct_user",
                component: resolve =>
                  require(["../components/pages/statistics/userProduct_user.vue"], resolve)
              },
              //产品统计 出口国
              {
                path: "userProductDestcountryDetail",
                component: resolve =>
                  require(["../components/pages/statistics/userProductDestcountryDetail.vue"], resolve)
              },
              //产品统计
              {
                path: "userProductDetail",
                component: resolve =>
                  require(["../components/pages/statistics/userProductDetail.vue"], resolve)
              },


              //用户产品统计
              {
                path: "userProduct_product",
                component: resolve =>
                  require(["../components/pages/statistics/userProduct_product.vue"], resolve)
              },
              //产品统计-用户分布
              {
                path: "userProduct_series",
                component: resolve =>
                  require(["../components/pages/statistics/userProduct_series.vue"], resolve)
              },


              {
                path: "destcountryDetail",
                component: resolve =>
                  require(["../components/pages/statistics/destcountryDetail.vue"], resolve)
              },
              //已结关出口量
              {
                path: "exportAmountpass",
                component: resolve =>
                  require(["../components/pages/statistics/exportAmountpass.vue"], resolve)
              },
              //未结关出口量
              {
                path: "exportAmountunpass",
                component: resolve =>
                  require(["../components/pages/statistics/exportAmountunpass.vue"], resolve)
              },

              //跟单员跟单数统计
              {
                path: "contactStatic",
                component: resolve =>
                  require(["../components/pages/statistics/contactStatic.vue"], resolve)
              },
              //通过率
              {
                path: "contactStaticDetail",
                component: resolve =>
                  require(["../components/pages/statistics/contactStaticDetail.vue"], resolve)
              },
              //未结关出口量
              // {
              //   path: "zhongxin",
              //   component: resolve =>
              //     require(["../components/pages/statistics/zhongxin.vue"], resolve)
              // },
              // 用户单据统计

              // 信息库
              //知识产权库
              {
                path: "knowledgeList",
                component: resolve =>
                  require(["../components/pages/info/knowledgeList.vue"], resolve)
              },
              //知识产权库
              {
                path: "productBrandList",
                component: resolve =>
                  require(["../components/pages/info/brandList.vue"], resolve)
              },
              // 信息库
            ]
        },
        {
            path: "/404",
            component: resolve => require(["../components/404.vue"], resolve)
        },

        {
            path: "*",
            redirect: "/404"
        }
    ]
});



// WEBPACK FOOTER //
// ./src/router/index.js